import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { ComponentProps } from 'react';
import type { LotteryName } from '../../../../lottery-purchases/types';
import { getLotteryResultsHref } from '../../../utils';

type ResultsSectionLinkProps = Omit<ComponentProps<typeof Link>, 'href'> & {
  lottery: LotteryName;
};

/**
 * Displays a link to the prize breakdown page for a given lottery.
 * Namespace for translations: 'lotteries.results.mini'.
 * Key for translations: 'view_prize_breakdown'.
 *
 * @param {LotteryName} lottery - The identifier of the lottery.
 * @returns {JSX.Element} The rendered component.
 */
function ResultsSectionLink({ lottery, className, ...props }: ResultsSectionLinkProps) {
  const t = useTranslations('lotteries.results.mini');
  return (
    <Link href={getLotteryResultsHref(lottery) ?? ''} className={twMerge('link-label-explanatory underline', className)} data-testid="prize-breakdown-link" {...props}>
      {t('view_prize_breakdown')}
    </Link>
  );
}
export { ResultsSectionLink };
